import React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { Typography, CardHeader, CardContent, Stack } from "@mui/material";
import { ChartCard } from "../Style/health-chart.style";

export default function AgeWiseGenderChart({ ageWiseData, selectedDistrict, tabValue, diseaseName = 'Screening' }) {
  // Use the provided data
  const dataToUse = ageWiseData;

  // Transform data for the chart
  const ageGroups = ['18-29', '30-39', '40-49', '50-59', '60+'];

  // Prepare data for the chart
  const chartData = ageGroups.map(ageGroup => {
    const male = dataToUse?.[ageGroup]?.male ? Number(dataToUse[ageGroup].male) : 0;
    const female = dataToUse?.[ageGroup]?.female ? Number(dataToUse[ageGroup].female) : 0;
    return {
      ageGroup,
      male,
      female,
      total: male + female
    };
  });

  return (
    <ChartCard>
      <CardHeader
        title={
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", fontSize: "14px", textAlign: 'center', textDecorationLine: 'underline' }}
          >
            Age wise {diseaseName} cases of male/female
          </Typography>
        }
        sx={{ pb: 2 }}
      />
      <CardContent sx={{ height: '100%' }}>
        <BarChart
          xAxis={[{
            scaleType: 'linear',
            tickLabelStyle: { fontSize: 12 },
          }]}
          yAxis={[{
            scaleType: 'band',
            data: ageGroups,
            tickLabelStyle: { fontSize: 12 },
          }]}
          series={[
            {
              data: chartData.map(item => item.male),
              label: 'Male',
              color: '#2196f3',
              stack: 'total',
            },
            {
              data: chartData.map(item => item.female),
              label: 'Female',
              color: '#ff69b4',
              stack: 'total',
            },
          ]}
          layout="horizontal"
          height={400}
          slotProps={{
            legend: {
              direction: 'row',
              position: { horizontal: 'center', vertical: 'bottom' },
            },
          }}
        />
      </CardContent>
    </ChartCard>
  );
}
